import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.less']
})
export class MainPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $("app-footer").css("display", "none");
    $("app-sidenav").css("display", "none");
    $("app-navbar").css("display", "none");
  }

  printPage() {
    window.print();
  }

}
